import MinMaxParam from "./MinMaxViewModel"

export default class PieChartOptionsViewModel {
    direction: "arrivals" | "departures" | "totals" = "totals"
    period: "all" | "select" | "peak" = "all"
    selectedTime: MinMaxParam | null = null;
}
